import { SvgIcon } from '@mui/material';

const GroupSenior = (props) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path d="M14,9.5A2.5,2.5,0,1,1,16.5,12,2.5,2.5,0,0,1,14,9.5ZM9,11A3,3,0,1,0,6,8,3,3,0,0,0,9,11Zm5.45,3.66A3,3,0,0,0,11.76,13H6.24a3,3,0,0,0-2.69,1.66L2.11,17.55A1,1,0,0,0,3,19H15a1,1,0,0,0,.89-1.45Zm7.44,2.89-.95-1.9A3,3,0,0,0,18.26,14H16.35l1.33,2.66A3,3,0,0,1,17.83,19H21A1,1,0,0,0,21.89,17.55Z" />
        </SvgIcon>
    );
};

export default GroupSenior;
